import { apiCall } from './gqlClient';

const GETALLPROVIDERS_QUERY = `
  query getAllProviders {
    getAllProviders
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getAllProvidersApiCall = async (fragments = null) => apiCall({ query: GETALLPROVIDERS_QUERY, variables: {}, fragments });

const GETPROVIDERDETAILS_QUERY = `
  query getProviderDetails($id: Int!) {
    getProviderDetails(id: $id)
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getProviderDetailsApiCall = async ({id}, fragments = null) => apiCall({ query: GETPROVIDERDETAILS_QUERY, variables: {id}, fragments });

const GETRANDOMPROVIDERS_QUERY = `
  query getRandomProviders {
    getRandomProviders
  }`;

export const getRandomProvidersApiCall = async () => apiCall({ query: GETRANDOMPROVIDERS_QUERY, variables: {}});

const GETRANDOMPROVIDERSALSOBYKEYWORDORADDRESS_QUERY = `
  query getRandomProvidersAlsoByKeywordOrAddress($keyword: String, $city: String, $country: String, $type: String) {
    getRandomProvidersAlsoByKeywordOrAddress(keyword: $keyword, city: $city, country: $country, type: $type)
  }`;

export const getRandomProvidersAlsoByKeywordOrAddressApiCall = async ({keyword, city, country, type}, ) => apiCall({ query: GETRANDOMPROVIDERSALSOBYKEYWORDORADDRESS_QUERY, variables: {keyword, city, country, type}});

const GETPROVIDERS_QUERY = `
  query getProviders($categoryId: Int, $cityId: Int, $providerType: String, $keyword: String, $onlyMyMemberships: Boolean, $onlyActive: Boolean) {
    getProviders(categoryId: $categoryId, cityId: $cityId, providerType: $providerType, keyword: $keyword, onlyMyMemberships: $onlyMyMemberships, onlyActive: $onlyActive)
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getProvidersApiCall = async ({categoryId, cityId, providerType, keyword, onlyMyMemberships, onlyActive}, fragments = null) => apiCall({ query: GETPROVIDERS_QUERY, variables: {categoryId, cityId, providerType, keyword, onlyMyMemberships, onlyActive}, fragments });

const GETMYPROVIDERS_QUERY = `
  query getMyProviders {
    getMyProviders
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getMyProvidersApiCall = async (fragments = null) => apiCall({ query: GETMYPROVIDERS_QUERY, variables: {}, fragments });

const GETALLPROVIDERRESOURCES_QUERY = `
  query getAllProviderResources($providerId: Int!) {
    getAllProviderResources(providerId: $providerId)
    {
      id
			resTypeId
			userId
			name
			gender
			providers
			role
			quantity
			capacity
			archive
      ...fragments
    }
  }`;

export const getAllProviderResourcesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETALLPROVIDERRESOURCES_QUERY, variables: {providerId}, fragments });

const GETALLPROVIDERCUSTOMERSANDRESOURCES_QUERY = `
  query getAllProviderCustomersAndResources($providerId: Int!) {
    getAllProviderCustomersAndResources(providerId: $providerId)
    {
      id
			name
			phone
			email
			role
			active
			image
			codiceFiscale
			piva
			sdi
			created
      ...fragments
    }
  }`;

export const getAllProviderCustomersAndResourcesApiCall = async ({providerId}, fragments = null) => apiCall({ query: GETALLPROVIDERCUSTOMERSANDRESOURCES_QUERY, variables: {providerId}, fragments });

const GETALLPROVIDERSWITHPLANS_QUERY = `
  query getAllProvidersWithPlans {
    getAllProvidersWithPlans
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getAllProvidersWithPlansApiCall = async (fragments = null) => apiCall({ query: GETALLPROVIDERSWITHPLANS_QUERY, variables: {}, fragments });

const GETPROVIDERGENERALINFORMATION_QUERY = `
  query getProviderGeneralInformation($id: Int) {
    getProviderGeneralInformation(id: $id)
    {
      id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			subscribed
			userHasMembership
			membershipsCounter
			freeCancellationHours
			reservationOffset
			hasConnectedPaymentAccount
			defaultTimeSlotStep
			language
			ownerId
			locked
			free
			ordersNumber
			notificationEmail
			appName
			clientProvider
			timezone
			canUnlock
			joinPolicy
			approvalMethod
      ...fragments
    }
  }`;

export const getProviderGeneralInformationApiCall = async ({id}, fragments = null) => apiCall({ query: GETPROVIDERGENERALINFORMATION_QUERY, variables: {id}, fragments });

const GETPROVIDERIMAGES_QUERY = `
  query getProviderImages {
    getProviderImages
    {
      id
			providerId
			orderIndex
			file
			orig
			xLarge
			large
			medium
			small
			tempFileId
      ...fragments
    }
  }`;

export const getProviderImagesApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERIMAGES_QUERY, variables: {}, fragments });

const GETCOLLABORATORPERCENT_QUERY = `
  query getCollaboratorPercent {
    getCollaboratorPercent
    {
      id
			providerId
			type
			amountType
			amount
      ...fragments
    }
  }`;

export const getCollaboratorPercentApiCall = async (fragments = null) => apiCall({ query: GETCOLLABORATORPERCENT_QUERY, variables: {}, fragments });

const GETBOOKEDEVENTSCOLLABORATORPERCENT_QUERY = `
  query getBookedEventsCollaboratorPercent($startTime: DateTime, $endTime: DateTime, $email: String, $resourceId: Int, $entityType: String) {
    getBookedEventsCollaboratorPercent(startTime: $startTime, endTime: $endTime, email: $email, resourceId: $resourceId, entityType: $entityType)
    {
      id
			serviceId
			created
			name
			email
			startTime
			endTime
			type
			entityType
			status
			duration
			capacity
			totalCapacity
			classId
			subServiceId
			serviceName
			price
			collaboratorPercentPrice
      ...fragments
    }
  }`;

export const getBookedEventsCollaboratorPercentApiCall = async ({startTime, endTime, email, resourceId, entityType}, fragments = null) => apiCall({ query: GETBOOKEDEVENTSCOLLABORATORPERCENT_QUERY, variables: {startTime, endTime, email, resourceId, entityType}, fragments });

const GETTOP100MOSTACTIVEPROVIDERS_QUERY = `
  query getTop100MostActiveProviders($startDate: DateTime!, $endDate: DateTime!) {
    getTop100MostActiveProviders(startDate: $startDate, endDate: $endDate)
  }`;

export const getTop100MostActiveProvidersApiCall = async ({startDate, endDate}, ) => apiCall({ query: GETTOP100MOSTACTIVEPROVIDERS_QUERY, variables: {startDate, endDate}});

const GETNOTIFICATIONSSETTINGS_QUERY = `
  query getNotificationsSettings {
    getNotificationsSettings
    {
      users
			visitatore
			collaborators
			provider
      ...fragments
    }
  }`;

export const getNotificationsSettingsApiCall = async (fragments = null) => apiCall({ query: GETNOTIFICATIONSSETTINGS_QUERY, variables: {}, fragments });

const GETSMSNOTIFICATIONSSETTINGS_QUERY = `
  query getSmsNotificationsSettings {
    getSmsNotificationsSettings
    {
      users
			visitatore
			collaborators
			provider
      ...fragments
    }
  }`;

export const getSmsNotificationsSettingsApiCall = async (fragments = null) => apiCall({ query: GETSMSNOTIFICATIONSSETTINGS_QUERY, variables: {}, fragments });

const GETPROVIDERSWHEREUSERASSIGNEDASCOLLABORATOR_QUERY = `
  query getProvidersWhereUserAssignedAsCollaborator($userId: Int!) {
    getProvidersWhereUserAssignedAsCollaborator(userId: $userId)
    {
      id
			name
			role
      ...fragments
    }
  }`;

export const getProvidersWhereUserAssignedAsCollaboratorApiCall = async ({userId}, fragments = null) => apiCall({ query: GETPROVIDERSWHEREUSERASSIGNEDASCOLLABORATOR_QUERY, variables: {userId}, fragments });

const GETPROVIDERCOMPLETEDTASKS_QUERY = `
  query getProviderCompletedTasks {
    getProviderCompletedTasks
    {
      hasServices
			hasCourses
			hasEvents
			hasStaff
			hasMemberships
			hasVideos
			hasImages
      ...fragments
    }
  }`;

export const getProviderCompletedTasksApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERCOMPLETEDTASKS_QUERY, variables: {}, fragments });

const GETPROVIDERTYPETOKENS_QUERY = `
  query getProviderTypeTokens {
    getProviderTypeTokens
    {
      type
      ...fragments
    }
  }`;

export const getProviderTypeTokensApiCall = async (fragments = null) => apiCall({ query: GETPROVIDERTYPETOKENS_QUERY, variables: {}, fragments });

const TOGGLEPROVIDERSTATUS_QUERY = `
  mutation toggleProviderStatus($id: Int!, $status: Boolean!) {
    toggleProviderStatus(id: $id, status: $status)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const toggleProviderStatusApiCall = async ({id, status}, fragments = null) => apiCall({ query: TOGGLEPROVIDERSTATUS_QUERY, variables: {id, status}, fragments });

const UPDATEPROVIDERPAYMENTSETTINGS_QUERY = `
  mutation updateProviderPaymentSettings($freeCancellationHours: Int!, $onlineDiscount: Int, $reservationOffset: Int, $paymentOptions: PaymentOptionsInput, $collaboratorPercent: CollaboratorPercentInput) {
    updateProviderPaymentSettings(freeCancellationHours: $freeCancellationHours, onlineDiscount: $onlineDiscount, reservationOffset: $reservationOffset, paymentOptions: $paymentOptions, collaboratorPercent: $collaboratorPercent)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateProviderPaymentSettingsApiCall = async ({freeCancellationHours, onlineDiscount, reservationOffset, paymentOptions, collaboratorPercent}, fragments = null) => apiCall({ query: UPDATEPROVIDERPAYMENTSETTINGS_QUERY, variables: {freeCancellationHours, onlineDiscount, reservationOffset, paymentOptions, collaboratorPercent}, fragments });

const CREATEPROVIDER_QUERY = `
  mutation createProvider($request: ProviderCreateInput!) {
    createProvider(request: $request)
    {
      success
			id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			locked
      ...fragments
    }
  }`;

export const createProviderApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEPROVIDER_QUERY, variables: {request}, fragments });

const CREATEPROVIDERONBOARD_QUERY = `
  mutation createProviderOnboard($request: ProviderCreateOnboardInput!) {
    createProviderOnboard(request: $request)
    {
      success
			id
			cityId
			name
			type
			description
			address
			postcode
			country
			phone
			latitude
			longitude
			acceptPayments
			onlineDiscount
			time
			timeNote
			tags
			url
			blog
			facebook
			twitter
			linkedin
			skype
			instagram
			youtube
			email
			role
			created
			active
			locked
      ...fragments
    }
  }`;

export const createProviderOnboardApiCall = async ({request}, fragments = null) => apiCall({ query: CREATEPROVIDERONBOARD_QUERY, variables: {request}, fragments });

const UPDATEPROVIDER_QUERY = `
  mutation updateProvider($request: ProviderUpdateInput!) {
    updateProvider(request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateProviderApiCall = async ({request}, fragments = null) => apiCall({ query: UPDATEPROVIDER_QUERY, variables: {request}, fragments });

const UPDATEPROVIDERBYADMIN_QUERY = `
  mutation updateProviderByAdmin($id: Int!, $request: ProviderUpdateInput!) {
    updateProviderByAdmin(id: $id, request: $request)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateProviderByAdminApiCall = async ({id, request}, fragments = null) => apiCall({ query: UPDATEPROVIDERBYADMIN_QUERY, variables: {id, request}, fragments });

const DELETEPROVIDERIMAGE_QUERY = `
  mutation deleteProviderImage($id: String!) {
    deleteProviderImage(id: $id)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const deleteProviderImageApiCall = async ({id}, fragments = null) => apiCall({ query: DELETEPROVIDERIMAGE_QUERY, variables: {id}, fragments });

const ADDIMAGEINPROVIDERGALLERY_QUERY = `
  mutation addImageInProviderGallery($name: String!, $metadata: ImageMetadataInput!) {
    addImageInProviderGallery(name: $name, metadata: $metadata)
    {
      id
			presignedUrl
			signedUrl
			success
			name
			sectionIndex
      ...fragments
    }
  }`;

export const addImageInProviderGalleryApiCall = async ({name, metadata}, fragments = null) => apiCall({ query: ADDIMAGEINPROVIDERGALLERY_QUERY, variables: {name, metadata}, fragments });

const REORDERPROVIDERGALLERY_QUERY = `
  mutation reorderProviderGallery($oldPosition: Int!, $newPosition: Int!) {
    reorderProviderGallery(oldPosition: $oldPosition, newPosition: $newPosition)
  }`;

export const reorderProviderGalleryApiCall = async ({oldPosition, newPosition}, ) => apiCall({ query: REORDERPROVIDERGALLERY_QUERY, variables: {oldPosition, newPosition}});

const ADMINUPDATEPROVIDERSUBSCRIPTIONENDTIME_QUERY = `
  mutation adminUpdateProviderSubscriptionEndTime($providerId: Int!, $endsAt: String!) {
    adminUpdateProviderSubscriptionEndTime(providerId: $providerId, endsAt: $endsAt)
    {
      success
			message
			id
			name
			idx
			title
      ...fragments
    }
  }`;

export const adminUpdateProviderSubscriptionEndTimeApiCall = async ({providerId, endsAt}, fragments = null) => apiCall({ query: ADMINUPDATEPROVIDERSUBSCRIPTIONENDTIME_QUERY, variables: {providerId, endsAt}, fragments });

const UNLOCKPROVIDER_QUERY = `
  mutation unlockProvider($id: Int!) {
    unlockProvider(id: $id)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const unlockProviderApiCall = async ({id}, fragments = null) => apiCall({ query: UNLOCKPROVIDER_QUERY, variables: {id}, fragments });

const UPDATENOTIFICATIONSSETTINGS_QUERY = `
  mutation updateNotificationsSettings($settings: NotificationsSettingsInput!) {
    updateNotificationsSettings(settings: $settings)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateNotificationsSettingsApiCall = async ({settings}, fragments = null) => apiCall({ query: UPDATENOTIFICATIONSSETTINGS_QUERY, variables: {settings}, fragments });

const UPDATESMSNOTIFICATIONSSETTINGS_QUERY = `
  mutation updateSmsNotificationsSettings($settings: NotificationsSettingsInput!) {
    updateSmsNotificationsSettings(settings: $settings)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateSmsNotificationsSettingsApiCall = async ({settings}, fragments = null) => apiCall({ query: UPDATESMSNOTIFICATIONSSETTINGS_QUERY, variables: {settings}, fragments });

const UPDATEPROVIDERJOINPOLICY_QUERY = `
  mutation updateProviderJoinPolicy($type: String!) {
    updateProviderJoinPolicy(type: $type)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateProviderJoinPolicyApiCall = async ({type}, fragments = null) => apiCall({ query: UPDATEPROVIDERJOINPOLICY_QUERY, variables: {type}, fragments });

const UPDATEPROVIDERAPPROVALMETHOD_QUERY = `
  mutation updateProviderApprovalMethod($type: String!) {
    updateProviderApprovalMethod(type: $type)
    {
      success
			message
			id
			id2
			name
			status
      ...fragments
    }
  }`;

export const updateProviderApprovalMethodApiCall = async ({type}, fragments = null) => apiCall({ query: UPDATEPROVIDERAPPROVALMETHOD_QUERY, variables: {type}, fragments });
